/**
 * A size in bytes, as somebody would say it.
 *
 * Written out rather than left to `Intl.NumberFormat`, which looks as though it
 * covers this -- `style: 'unit', unit: 'byte', notation: 'compact'` -- and does
 * not: compact notation shortens the *number* while the unit stays a byte, so
 * three gigabytes comes out as "3.2BB", where the first B is billions and the
 * second is bytes.
 *
 * Steps of 1024, which is what a file size means here: the sizes come from an
 * object store reporting the length of an archive.
 */
const UNITS = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'] as const

export function byteSize(bytes: number): string {
  if (!Number.isFinite(bytes) || bytes < 0) return ''

  let size = bytes
  let unit = 0
  while (size >= 1024 && unit < UNITS.length - 1) {
    size /= 1024
    unit += 1
  }

  // Whole bytes, and one decimal above that -- "1.5 KB" says something "1 KB"
  // does not, while "1.0 B" says less than "1 B".
  const digits = unit === 0 ? 0 : 1
  return `${size.toFixed(digits)} ${UNITS[unit]}`
}
